<script setup>

import CustomImage from "@/components/reuseables/customImage.vue";
import { defineProps } from "vue";

defineProps({
    header: {
        type: Object,
        required: true,
    },
});

function getLinkComponent(externalLink) {
    return externalLink ? 'a' : 'router-link';
}

function getLinkProps(secondLogo) {
    if (secondLogo?.externalLink) {
        return {
            href: secondLogo.externalLink,
            target: '_blank'
        };
    }
    return {
        to: ('/' + secondLogo?.pageLink?.url) || '/'
    };
}
</script>

<template>
    <router-link
        v-if="header?.logo?.[0]"
        to="/"
        title="Zur Startseite"
        class="logo"
    >
        <custom-image
            :image="header.logo[0]"
            background-color="white"
            width="100%"
            container-height="100%"
            :hover="false"
        />
    </router-link>

    <component
        v-if="header?.secondLogo?.[0]"
        :is="getLinkComponent(header.secondLogo[0].externalLink)"
        v-bind="getLinkProps(header.secondLogo[0])"
        :title="header.secondLogo[0].title"
        class="second-logo"
    >
        <custom-image
            :image="header.secondLogo[0]"
            background-color="white"
            width="100%"
            container-height="100%"
            :hover="false"
        />
    </component>
</template>
